
// AUTH
export const LOG_IN_USER = 'LOG_IN_USER';
export const LOG_OUT_USER = 'LOG_OUT_USER';

// FILTER
export const CHANGE_FILTER = 'CHANGE_FILTER';

// CURRENT CHANGE
export const SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL';

// COMMUNICATION
export const CHANGE_MESSAGE = 'CHANGE_MESSAGE';
export const SENDING_MESSAGE = 'SENDING_MESSAGE';
export const SET_PATH_SELECTED_MEDIA = 'SET_PATH_SELECTED_MEDIA';
export const PASTE_IMAGE = 'PASTE_IMAGE';
export const PREVIEW_IMAGE = 'PREVIEW_IMAGE';
export const CHANGE_IMAGE_COMPRESS = 'CHANGE_IMAGE_COMPRESS';
export const UPLOAD_IMAGE_PROGRESS = 'UPLOAD_IMAGE_PROGRESS';
export const CHANGE_IS_USER = 'CHANGE_IS_USER';
export const USERS_ONLINE = 'USERS_ONLINE';

